import Vue from 'vue'

const state = {
  bookRanking: [],
  bookHistory: [],
  searchBooks: [],
  isSearchShown: false,
};

const mutations = {
  'SET_RANKING_BOOKS' (state, books) {
    state.bookRanking = books;
  },
  'SET_HISTORY_BOOKS' (state, books) {
    state.bookHistory = books;
  },
  'SET_SEARCH_BOOKS' (state, books) {
    state.searchBooks = books;
  },
  'TOGGLE_SEARCH' (state, bool) {
    state.isSearchShown = bool;
  },
};

const actions = {
  getBookRanking: ({commit}, info) => {
    return Vue.http.get('webstore/ranking?token=' + info.token + "&type=" + info.type)
      .then(res => {
        return res.json();
      }, err => {
        return err.json();
      }).then(data => {
        if (data.error) {
          return 'error';
        }
        commit('SET_RANKING_BOOKS', data.book_list);
        return data;
      })
      .catch(() => {
        return 'error';
      });
  },
  getBookHistory: ({commit}) => {
    return Vue.http.get('webstore/book/purchased')
      .then(res => {
        return res.json();
      }, err => {
        return err.json();
      })
      .then(data => {
        if (data.error) {
          return 'error';
        }
        commit('SET_HISTORY_BOOKS', data.book_list);
      })
      .catch(() => {
        return 'error';
      });
  },
  getProductHistory: ({commit}, info) => {
    return Vue.http.get('webstore/product/purchased?token=' + info.token)
      .then(res => {
        return res.json();
      }, err => {
        return err.json();
      })
      .then(data => {
        if (data.error) {
          return 'error';
        }
        return data;
      })
      .catch(() => {
        return 'error';
      });
  },
  getBookCategories: ({commit}) => {
    return Vue.http.get('webstore/categories')
      .then(res => {
        return res.json();
      }, err => {
        return err.json();
      }).then(data => {
        commit('SET_CATEGORY', data.categories);
      });
  },
  searchBook: ({commit}, word) => {
    return Vue.http.get('webstore/book/search?q=' + word)
      .then(res => {
        return res.json();
      }, err => {
        return err.json();
      }).then(data => {
        commit('SET_SEARCH_BOOKS', data.book_list);
        return data.book_list;
      });
  },
  toggleSearch: ({commit}, bool) => {
    commit('TOGGLE_SEARCH', bool);
  },
  cancelHistoryPurchase: ({commit}, order) => {
    return Vue.http.post('webstore/book/purchase/cancel', order)
      .then(res => {
        return res.json();
      }, err => {
        return err.json();
      }).then(data => {
        //成功時のみ履歴を更新
        if (!data.message) {
          commit('SET_HISTORY_BOOKS', data.book_list);
        }
        return data;
      })
      .catch(data => {
        return false;
      });
  },
};

const getters = {
  bookRanking: state => {
    return state.bookRanking;
  },
  bookHistory: state => {
    return state.bookHistory;
  },
  searchBooks: state => {
    return state.searchBooks;
  },
  isSearchShown: state => {
    return state.isSearchShown;
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/books.js